import { KYMW1900Component } from './kymw1900.component';

/**
 * 組合員の声検索画面の値を管理するクラス
 *
 * @export KYMW1900Model
 * @class KYMW1900Model
 */
export class KYMW1900Model {

  kymw1900Component: KYMW1900Component;

  /**
   * 受付番号（From）
   */
  public receiptNumFrom: string = <string>'';

  /**
   * 受付番号（To）
   */
  public receiptNumTo: string = <string>'';

  /**
   * 部門
   */
  public classCode: string = <string>'';

  /**
   * 商品名
   */
  public subject: string = <string>'';

  /**
   * 問合せ内容
   */
  public inquiryContents: string = <string>'';

  /**
   * 会員受付日（From）
   */
  public receiptDateFrom: string = <string>'';

  /**
   * 会員受付日（To）
   */
  public receiptDateTo: string = <string>'';

  /**
   * 掲載区分
   */
  public publishType: string = <string>'';

  /**
   * 生協コード
   */
  public coopCode: string = <string>'';

  /**
   * PEACE取込日（From）
   */
  public importDateFrom: string = <string>'';

  /**
   * PEACE取込日（To）
   */
  public importDateTo: string = <string>'';

}
